import { runtimeConfig } from '@/shared/config'
import { initObservability } from '@/shared/observability'

// Bootstrap до рендера: MSW в mock-режиме (dynamic import → tree-shake в проде)
// и observability.
export async function bootstrap(): Promise<void> {
  initObservability()

  if (runtimeConfig.API_MODE === 'mock') {
    const { startMockWorker } = await import('@/shared/mock')
    await startMockWorker()
  }
}
